import React from "react";
import {useStores} from "../../../stores";
import {useSearchParams} from "react-router";
import type {AdvancedSupplierBreakdownData} from "../../../services/ApiTypes";
import {IconButton, Menu, MenuItem} from "@mui/material";
import {MoreHoriz} from "@mui/icons-material";
import * as CategorizationReviewUrls from "../../categorization/classes/CategorizationReviewUrls";
import * as SupplierNormalizationUrls from "../../supplier-normalization/SupplierNormalizationUrls";

type Props = {
    data: AdvancedSupplierBreakdownData
}
export const ContextMenuAction: React.FC<Props> = ({data}) => {
    const {p, bagStore, authStore} = useStores();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [searchParams] = useSearchParams();
    const categorizationEditUrl = (bagStore.advanced.databagId && data.s_name) ? CategorizationReviewUrls.intentToURL(
        CategorizationReviewUrls.buildPath(bagStore.advanced.databagId),
        searchParams,
        {type: 'by_supplier', supplier: data.s_name},
    ) : ''
    const parentSupplierEditUrl = (bagStore.advanced.databagId && data.sp_name) ? SupplierNormalizationUrls.intentToURL(
        SupplierNormalizationUrls.buildPath(bagStore.advanced.databagId),
        searchParams,
        {type: 'by_parent_supplier', supplier: data.sp_name},
    ) : ''
    if (!categorizationEditUrl && !parentSupplierEditUrl) {
        return <></>
    }
    return <div>
        <IconButton
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}>
            <MoreHoriz/>
        </IconButton>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}>
            {categorizationEditUrl && <MenuItem
                onClick={handleClose}
                component="a"
                href={categorizationEditUrl}
                target="_blank"
                rel="noopener noreferrer">
                {authStore.hasEditPermission ? 'Edit ' : 'View '}category
            </MenuItem>}
            {parentSupplierEditUrl && <MenuItem
                onClick={handleClose}
                component="a"
                href={parentSupplierEditUrl}
                target="_blank"
                rel="noopener noreferrer">
                {authStore.hasEditPermission ? 'Edit ' : 'View '}{p.parentSupplierDataName.toLowerCase()}
            </MenuItem>}
        </Menu>
    </div>
}